import React from 'react'

import './Title.scss'
const Index = ({ children }) => {
  return <h2 className='a-title'>{children}</h2>
}

export default Index
